import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import {
    setRLSearchFields,
    setRLPagination
} from '../js/actions/index';

import { 
    Container, 
    Col, 
    Row, 
    Alert, 
    Button, 
    Form, 
    Dropdown, 
    DropdownButton, 
    Table,
    InputGroup,
    Tabs,
    Tab } from "react-bootstrap";

import {
    Folder,
    Search, 
    CardList, 
    Calendar4, 
    Shop, 
    ExclamationCircle, 
    Basket,
    ToggleOn, 
    ToggleOff, } from 'react-bootstrap-icons';

import moment from 'moment';
import { DateRangePicker } from "react-dates"; 

import NavbarComponent from '../components/NavbarComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import LoadingComponent from '../components/LoadingComponent';
import FooterComponent from '../components/FooterComponent';
import AuthErrorComponent from '../components/AuthErrorComponent';
import ServerErrorComponent from '../components/ServerErrorComponent';
import PaginationComponent from '../components/PaginationComponent';

import {NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN} from '../constants/ApiResult';
import {PO, GR} from '../constants/GlobalConstant';

// Services
import {
    getGoodsReceiptLists
} from "../services/GoodsReceipt";

const services = {
    getGoodsReceiptLists    
};

const axios = require('axios').default;
const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal';

function mapDispatchToProps(dispatch) {
    return {
        setRLSearchFields: type => dispatch(setRLSearchFields(type)),
        setRLPagination: type => dispatch(setRLPagination(type))
    };
}

class GoodsReceiptList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading:false,
            alertErrorMessage:null,
            authError:false,
            serverError:false,
            data:null,
            dataRL:null,
            paginationIntervals:0,
            paginationSize:20,
            rlPagination:1,
            filterOrderName:'',
            toggleOrderName:GR,
            filterBranchId:null,
            toggleDate:GR,
            startDate: null,
            endDate: null,
            rlState:[2],
        }
    }

    componentDidMount() {
        this.getGoodsReceiptListAPI();
    }

    /*
    API
    */

    // Error Handling

    handleErrorAPI = (err) => {
        console.error(err);
        this.setState({
            serverError:true,
            isLoading:false
        });
    }

// (GET) Goods Receipt List

    getGoodsReceiptListAPI = async () => {

        try {
            const props = {
              token: this.props.auth.token,
              state:JSON.stringify(this.state.rlState),
              businessId:this.props.auth.businessId,
              supplierId:this.props.auth.supplierId
            };

            const response = await getGoodsReceiptLists(props);
            let res = response.data;

            if([NO_USER_FOUND, FAILED_AUTHENTICATE_TOKEN].indexOf(res.result) > -1) {
                this.setState({
                    authError:true
                });
            } else {
                this.setState({
                    data: res.data,
                    dataRL:res.data
                });
            }
          } catch (err) {
            this.handleErrorAPI(err);
        }
    }

// Loading
isLoading = () => {
    if(!this.state.data && !this.state.errorMessage) {
        return true;
    }
    return false;
}

// RL Data
    getRLData = () => {
        let data = JSON.parse(JSON.stringify(this.state.data));

        // branch
        if(this.state.filterBranchId) {
            data = data.filter( (row) => row.branchId === this.state.filterBranchId );
        }

        // order name
        if(this.state.toggleOrderName === GR) {
            // RLOrderName
            data = data.filter( (row) => row.RLOrderName.toLowerCase().indexOf(this.state.filterOrderName.toLowerCase()) > -1);
        } else {
            // OrderName
            data = data.filter( (row) => row.OrderName.toLowerCase().indexOf(this.state.filterOrderName.toLowerCase()) > -1);
        }

        // date
        if(this.getRLSearchFields('startDate') && this.getRLSearchFields('endDate')) {
            // StorageDate (20 Jul 2020), poDeliveryDate (21 Jul 2020)
            let start = moment(this.getRLSearchFields('startDate')).format('YYYY-MM-DD');
            let end = moment(this.getRLSearchFields('endDate')).format('YYYY-MM-DD');
            
            data = data.filter( (row) => {
                let property = row.StorageDate;
                if(this.getRLSearchFields("dateType") === PO) {
                    property = row.poDeliveryDate;
                }
                return moment.utc(property).isBetween(moment(start).format('YYYY-MM-DD 00:00:00'), moment(end).format('YYYY-MM-DD 23:59:59'), null, '[]')
            });
        }

        return data;
    }

// RL Table Rows
    getRLTableRows = () => {
        let start = 0;
        let end = this.state.paginationSize;

        if(this.state.data.length === this.state.dataRL.length) {
            start = (this.state.rlPagination - 1) * this.state.paginationSize;
            end = this.state.rlPagination * this.state.paginationSize;
        }

        return this.getRLData().slice(start, end);
    }

// RLOrderName Click
    handleRLOrderNameClick = (RLId) => {
        this.props.history.push(`/goods-receipt/${RLId}`);
    }

// Pagination
    htmlPagination = () => {
        let paginationLength = 0;
        let paginationIntervals = 0;
        
        let data = this.getRLData();
 
        if(data.length) {
            paginationLength = data.length;
            paginationIntervals = Math.ceil(data.length / this.state.paginationSize);
        }

        if(paginationIntervals > 1) {
            return <PaginationComponent 
            active={this.state.rlPagination} 
            length={paginationLength} 
            intervals={paginationIntervals} 
            handleClickPaginationItem={this.handleClickPaginationItem} 
            />
        } else {
            return;
        }
        
    }

    handleClickPaginationItem = (page) => {
        this.props.setRLPagination(page);

        this.setState({
            rlPagination:page
        });
    }

/*
FILTERS
*/

    handleToggleFilterByOrderName =  () => {
        this.setState({
            toggleOrderName:this.state.toggleOrderName === GR ? PO : GR
        });
    }

    handleFilterByOrderName= (value) => {
        this.setState({
            filterOrderName:value
        });
    }

// Branch

    handleOnSelectFilterBranch = (value) => {
        this.setState({
            filterBranchId:parseInt(value)
        });
    }

    getFilterBranchTitle = () => {
        if(this.state.filterBranchId) {
            let filter = this.state.data.filter( (row) => row.branchId === this.state.filterBranchId )[0];
            if(filter) {
                return filter.BranchName;
            }
            return;
        }
        return "Select Branch";
    }

    htmlFilterBranchOptions = () => {
        let branches = [];
        this.state.data.forEach( (row) => {
            if(branches.findIndex( (branch) => branch.branchId === row.branchId ) === -1) {
                branches.push({
                    branchId:row.branchId,
                    branchName:row.BranchName
                });
            }
        });

        if(branches.length) {
            return branches.map( (branch, index) => {
            return <Dropdown.Item as="button" key={index} eventKey={branch.branchId}>{branch.branchName}</Dropdown.Item>
            });
        }
    }

/*
    Datepicker
*/

    handleOnDatesChange = (startDate, endDate) => {

        this.props.setRLSearchFields([{
            "field":"startDate",
            "value":moment(startDate).format('YYYY-MM-DD 00:00:00')
        },{
            "field":"endDate",
            "value":moment(endDate).format('YYYY-MM-DD 23:59:59')
        }]);

        this.setState({
            startDate:startDate,
            endDate:endDate
        });
    }

    handleToggleFilterDate = () => {

        this.props.setRLSearchFields([{
            "field":"dateType",
            "value":this.getRLSearchFields("dateType") === GR ? PO : GR
        }])

        this.setState({
            toggleDate:this.state.toggleDate === GR ? PO : GR
        })
    }

/*
    RL Search Fields
*/

    getRLSearchFields = (field) => {
        return this.props.rlSearchFields[field];
    }

/*
Tabs
*/

    handleSelectTab = () => {

    }

    htmlRLTab = (mode) => {
        return <>
            <Form className="d-sm-flex" onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="dropdown-filter-branch-button" className="mt-4 mr-4">
                    <Form.Label className="font-weight-bold"><Shop size={16} className="mb-1 mr-1" /> Branch</Form.Label>
                    <DropdownButton
                        id="dropdown-filter-branch-button"
                        title={this.getFilterBranchTitle()}
                        onSelect={this.handleOnSelectFilterBranch}
                    >
                    <Dropdown.Item as="button" eventKey="">All Branches</Dropdown.Item>
                        {this.htmlFilterBranchOptions()}
                    </DropdownButton>
                </Form.Group>
            </Form>

            <Row>
                <Col md={12} lg={6}>
                    <Form className="d-sm-flex" onSubmit={(e) => e.preventDefault()}>
                    <Form.Group controlId="search-rl-number" className="mt-4 mr-4">
                        <span className="font-weight-bold"><Search size={16} className="mb-1 mr-1" /> Filter</span>
                        <div className="mt-2">
                            <InputGroup>
                            <Button
                                id="search-rl-number" 
                                variant="secondary" 
                                className="mr-3 rounded"
                                onClick={ () => this.handleToggleFilterByOrderName()}>
                                {this.state.toggleOrderName === GR
                                ?
                                    <>
                                    <ToggleOff size={16} className="mb-1 mr-1" />
                                    <span>GR</span>
                                    </>
                                :
                                    <>
                                    <ToggleOn size={16} className="mb-1 mr-1" />
                                    <span>PO</span>
                                    </>
                                }
                            </Button>
                            <Form.Control 
                                type="textbox" 
                                name="search" 
                                placeholder={this.state.toggleOrderName === GR ? "Enter Goods Receipt Number" : "Enter Purchase Order Number"}
                                onChange={(e) => this.handleFilterByOrderName(e.currentTarget.value)}
                                value={this.state.filterOrderName}
                            />
                            {this.state.filterOrderName &&
                            <InputGroup.Text 
                                className="is-hover" 
                                onClick={ () => this.setState({
                                    "filterOrderName":""
                                })}
                            >
                                Clear
                            </InputGroup.Text>
                            }
                            </InputGroup>
                        </div>
                    </Form.Group>
                    </Form>
                </Col>
                <Col md={12} lg={6} className="text-lg-end mt-4">
                    <span className="font-weight-bold"><Calendar4 size={16} className="mb-1 mr-1" /> Date</span>
                    <div className="mt-2">
                        <Button 
                            variant="secondary" 
                            className="mr-3 rounded"
                            onClick={ () => this.handleToggleFilterDate()}>
                            {this.getRLSearchFields("dateType") === GR
                            ?
                                <>
                                <ToggleOff size={16} className="mb-1 mr-1" />
                                <span>GR</span>
                                </>
                            :
                                <>
                                <ToggleOn size={16} className="mb-1 mr-1" />
                                <span>PO</span>
                                </>
                            }
                        </Button>
                        {mode === 2 &&
                        <DateRangePicker
                            startDate={moment(this.getRLSearchFields('startDate'))._isValid && moment(this.getRLSearchFields('startDate'))}
                            startDateId="start_date_id"
                            endDate={moment(this.getRLSearchFields('endDate'))._isValid && moment(this.getRLSearchFields('endDate'))}
                            endDateId="end_date_id"
                            onDatesChange={({ startDate, endDate }) =>
                                this.handleOnDatesChange(startDate, endDate)
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) => this.setState({ focusedInput, dataLength: 0 })}
                            id={`singledatepicker${mode}`}
                            orientation={orientation}
                            isOutsideRange={() => {
                                return false;
                            }}
                            displayFormat={() => "DD/MM/YYYY"}
                            minimumNights={0}
                            small={true}
                        />
                        }
                    </div>
                </Col>
            </Row>

            {!this.getRLData().length &&               
            <Alert className="bg-info text-white mt-4">
                <ExclamationCircle size={16} className="mb-1 mr-1" />No Results
            </Alert>
            }

            <Table 
                bordered 
                hover 
                size="sm" 
                responsive 
                className="text-xs-nowrap mt-4">
                <thead>
                    <tr>
                        {/*<th><Folder size={16} className="mb-1 mr-1" /></th>*/}
                        <th><CardList size={16} className="mb-1 mr-1" /> GRN</th>
                        <th><Calendar4 size={16} className="mb-1 mr-1" /> Receipted</th>
                        <th><CardList size={16} className="mb-1 mr-1" /> PO Number</th>
                        <th><Calendar4 size={16} className="mb-1 mr-1" /> PO Delivery</th>
                        <th><Shop size={16} className="mb-1 mr-1" /> Branch</th>
                        <th><Basket size={16} className="mb-1 mr-1" /> Supplier</th>
                    </tr>
                </thead>
                <tbody>
                    {this.getRLTableRows().map( (row, index) => {
                        return (
                        <tr key={index}>
                            {/*<td className="bg-success"></td>*/}
                            <td>
                                <Button 
                                    variant="link" 
                                    type="button" 
                                    onClick={() => this.handleRLOrderNameClick(row.RLId)}
                                    className="text-left"
                                >
                                {row.RLOrderName}
                                </Button>
                            </td>
                            <td>{moment(row.StorageDate).utc().format('D MMM YYYY')}</td>
                            <td>{row.OrderName}</td>
                            <td>{moment(row.poDeliveryDate).utc().format('D MMM YYYY')}</td>
                            <td>{row.BranchName}</td>
                            <td>{row.SupplierName}</td>
                        </tr>
                        )
                    })}
                </tbody>
            </Table>
        
            <div>
                {this.htmlPagination()}
            </div>
        </>
    }

/*
    Render
*/

    render() {
        return (
            <>
            <Container className="p-0">
                {this.props.auth.isLogin && <NavbarComponent />}
                <Container fluid>
                    <Row>
                        <Col>
                            <div className="mt-4">
                                <h1>Goods Receipt List</h1>
                            </div>

                            {this.state.authError
                            ?
                                <AuthErrorComponent />
                            :
                            
                            (this.state.serverError)
                            
                            ?
                                <ServerErrorComponent />
                            :

                            this.isLoading()
                            ?
                                <LoadingComponent />
                            :
                            <>

                            <Tabs
                                activeKey={!this.props.rlType ? 2 : this.props.rlType}
                                id="rl-tab" 
                                className="mt-4" 
                                onSelect={ (value) => this.handleSelectTab(value)}
                            >
                                <Tab eventKey={1} title="收貨" disabled={true}>
                                    <div className="mb-4">
                                        {this.htmlRLTab(1)}
                                    </div>
                                </Tab>
                                <Tab eventKey={3} title="部分收貨" disabled={true}>
                                    <div className="mb-4">
                                        {this.htmlRLTab(3)}
                                    </div>
                                </Tab>
                                <Tab eventKey={2} title="已完成收貨">
                                    <div className="mb-4">
                                        {this.htmlRLTab(2)}
                                    </div>
                                </Tab>
                            </Tabs>
                            </>
                            }         
                        </Col>
                    </Row>
                </Container>
            </Container>
            <FooterComponent />
            </>
        )
    }

}

const mapStateToProps = state => {
    const {
        auth,
        rlSearchFields,
        rlPagination
    } = state;

    return { 
        auth: auth,
        rlSearchFields:rlSearchFields,
        rlPagination:rlPagination
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GoodsReceiptList));